<template>
  <div class="d-flex">
    <img
        alt="Geomob"
        :class="['gmb-brand-logo', { 'gmb-brand-logo--large': isLarge }]"
        :src="imagePath"
    />
  </div>
</template>

<script>
export default {
  name: "GmbBrandLogo",

  components: {},

  props: {
    isLarge: Boolean,
  },

  data() {
    return {
      imagePath: require("@/assets/brand-logo.svg"),
    };
  },

  computed: {},

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {},
};
</script>

<style lang="scss">
@import "@/sass/settings/dimensions";

/* =========================================================================
 * BRAND LOGO
 * ========================================================================= */

.gmb-brand-logo {
  &--large {
    height: $gmb-brand-logo-height-large;
  }

  &:not(.gmb-brand-logo--large) {
    height: $gmb-brand-logo-height-normal;
  }
}
</style>
